import React, { useState } from 'react';
import { UnmountClosed as Collapse } from 'react-collapse';
import { Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames';

import './stylesheet.css';

import LeadTimeRule from '../LeadTimeRule';

export default ({ cadence, index, onFieldPathUpdate, onDeleteCadence }) => {
  const [isCollapsed, setIsCollapsed] = useState(!!cadence.get('tag'));
  const handleHeaderBarClick = () => setIsCollapsed(!isCollapsed);

  const updateField = (fieldName) => (event) =>
    onFieldPathUpdate(cadence.get('id'), [fieldName], event.target.value);

  const toggleRule = (fieldName) => () =>
    onFieldPathUpdate(
      cadence.get('id'),
      [fieldName, 'enabled'],
      !cadence.getIn([fieldName, 'enabled'])
    );

  const updateRuleValue = (fieldName) => (event) =>
    onFieldPathUpdate(cadence.get('id'), [fieldName, 'value'], event.target.value);

  const updateRuleUnit = (fieldName) => (newUnit) =>
    onFieldPathUpdate(cadence.get('id'), [fieldName, 'unit'], newUnit);

  const handleDeleteClick = () => {
    const tag = cadence.get('tag');
    const label = tag ? `:${tag}:` : 'this tag cadence';
    if (window.confirm(`Are you sure you want to delete ${label}?`)) {
      onDeleteCadence(cadence.get('id'));
    }
  };

  const caretClassName = classNames(
    'fas fa-2x fa-caret-right notification-tag-cadence-container__header__caret',
    {
      'notification-tag-cadence-container__header__caret--rotated': !isCollapsed,
    }
  );

  const title = cadence.get('tag') ? `:${cadence.get('tag')}:` : 'New tag cadence';

  return (
    <Draggable draggableId={`notification-tag-cadence--${cadence.get('id')}`} index={index}>
      {(provided, snapshot) => (
        <div
          className={classNames('notification-tag-cadence-container', {
            'notification-tag-cadence-container--dragging': snapshot.isDragging,
          })}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <div
            className="notification-tag-cadence-container__header"
            onClick={handleHeaderBarClick}
          >
            <i className={caretClassName} />
            <span className="notification-tag-cadence-container__header__title">{title}</span>
            <i
              className="fas fa-bars fa-lg notification-tag-cadence-container__header__drag-handle"
              {...provided.dragHandleProps}
            />
          </div>

          <Collapse isOpened={!isCollapsed} springConfig={{ stiffness: 300 }}>
            <div className="notification-tag-cadence-container__content">
              <div className="notification-setting__field-container">
                <div className="notification-setting__field">
                  <div>Tag:</div>
                  <input
                    type="text"
                    className="textfield"
                    placeholder="e.g., meeting"
                    value={cadence.get('tag', '')}
                    onChange={updateField('tag')}
                    autoCapitalize="none"
                    autoCorrect="none"
                  />
                </div>
                <div className="notification-setting__help-text">
                  Headings with this tag use this cadence instead of the default reminders.
                </div>
              </div>

              <LeadTimeRule
                label="Scheduled"
                rule={cadence.get('scheduled')}
                onToggle={toggleRule('scheduled')}
                onValueChange={updateRuleValue('scheduled')}
                onUnitChange={updateRuleUnit('scheduled')}
              />
              <LeadTimeRule
                label="Deadline"
                rule={cadence.get('deadline')}
                onToggle={toggleRule('deadline')}
                onValueChange={updateRuleValue('deadline')}
                onUnitChange={updateRuleUnit('deadline')}
              />
              <LeadTimeRule
                label="Timestamp"
                rule={cadence.get('timestamp')}
                onToggle={toggleRule('timestamp')}
                onValueChange={updateRuleValue('timestamp')}
                onUnitChange={updateRuleUnit('timestamp')}
              />

              <div className="notification-setting__field-container notification-tag-cadence__delete-button-container">
                <button
                  className="btn settings-btn notification-tag-cadence__delete-button"
                  onClick={handleDeleteClick}
                >
                  Delete cadence
                </button>
              </div>
            </div>
          </Collapse>
        </div>
      )}
    </Draggable>
  );
};
